import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { StatusDasEntregasService } from './status-das-entregas.service';
import { StatusRoteiroPedidos } from '../shared/Util';
import { NgIf, NgStyle } from '@angular/common';
import { CardStatusEntregasComponent } from './card-status-entregas/card-status-entregas.component';

@Component({
    selector: 'app-status-das-entregas',
    templateUrl: './status-das-entregas.component.html',
    styleUrls: ['./status-das-entregas.component.css'],
    standalone: true,
    imports: [NgIf, NgStyle, CardStatusEntregasComponent]
})
export class StatusDasEntregasComponent implements OnChanges {

  @Input() dashboardResult = [];
  @Input() totais: any;
  dadosPedidos: any; 

  atendidos = { porcetagem: 0, peso: 0 ,valor : 0};
  naoAtendidos = { porcetagem: 0, peso: 0 ,valor : 0};
  emAnalise = { porcetagem: 0, peso: 0 ,valor : 0};
  pendentes = { porcetagem: 0, peso: 0 ,valor : 0};


  constructor(
    private statusDasEntregasService: StatusDasEntregasService,
  ) { }

  ngOnChanges(): void {
    let strRoteiros = this.dashboardResult.map((roteiro) => roteiro.NumeroRoteiro).join(', ');  
    this.getStatusDeEntregas(strRoteiros);    
  }


  async getStatusDeEntregas(strRoteiros: String){
    if(strRoteiros){
      this.dadosPedidos = await this.statusDasEntregasService.getStatusDeEntregas(strRoteiros)
      this.atualizaTotalizadores();
    } else{
      this.atendidos = { porcetagem: 0, peso: 0 ,valor : 0};
      this.naoAtendidos = { porcetagem: 0, peso: 0 ,valor : 0};
      this.emAnalise = { porcetagem: 0, peso: 0 ,valor : 0};
      this.pendentes = { porcetagem: 0, peso: 0 ,valor : 0};
    }
  }

  atualizaTotalizadores(){   
    this.atualizaAtendidos();
    this.atualizaNaoAtendidos();
    this.atualizaEmAnalise();
    this.atualizaPendentes();
  }


  atualizaAtendidos(){
    let listaFiltrada =  this.dadosPedidos.filter((pedido) =>   [StatusRoteiroPedidos.EntregaFinalizada, StatusRoteiroPedidos.EntregaParcial].includes( pedido.IdRoteiroPedidoSituacao) )    
    this.atendidos.valor = listaFiltrada.reduce((preVal, elem) => preVal + elem.ValorPedido, 0);
    this.atendidos.peso = listaFiltrada.reduce((preVal, elem) => preVal + elem.Peso, 0);    
    this.atendidos.porcetagem = +((this.totais.totalClientesAtendidos / this.totais.totalClientes) * 100 ).toFixed(2)
  }

  atualizaNaoAtendidos(){
    let listaFiltrada =  this.dadosPedidos.filter((pedido) =>   [StatusRoteiroPedidos.RecebimentoRecusado].includes( pedido.IdRoteiroPedidoSituacao) )  
    this.naoAtendidos.valor = listaFiltrada.reduce((preVal, elem) => preVal + elem.ValorPedido, 0);
    this.naoAtendidos.peso = listaFiltrada.reduce((preVal, elem) => preVal + elem.Peso, 0);    
    this.naoAtendidos.porcetagem = +((this.totais.totalClientesNaoAtendidos / this.totais.totalClientes) * 100 ).toFixed(2)
  }

  atualizaEmAnalise(){
    let listaFiltrada =  this.dadosPedidos.filter((pedido) =>  pedido.emAnalise )  
    this.emAnalise.valor = listaFiltrada.reduce((preVal, elem) => preVal + elem.ValorPedido, 0);
    this.emAnalise.peso = listaFiltrada.reduce((preVal, elem) => preVal + elem.Peso, 0);    
    this.emAnalise.porcetagem = +((this.totais.totalClientesAnalise / this.totais.totalClientes) * 100 ).toFixed(2)
  }

  atualizaPendentes(){
    let listaFiltrada =  this.dadosPedidos.filter((pedido) => 
        ![StatusRoteiroPedidos.EntregaFinalizada, StatusRoteiroPedidos.EntregaParcial, StatusRoteiroPedidos.RecebimentoRecusado].includes( pedido.IdRoteiroPedidoSituacao) 
        && !pedido.emAnalise
    )
    this.pendentes.valor = listaFiltrada.reduce((preVal, elem) => preVal + elem.ValorPedido, 0);
    this.pendentes.peso = listaFiltrada.reduce((preVal, elem) => preVal + elem.Peso, 0);     
    this.pendentes.porcetagem = +((this.totais.totalClientesNaoVisitados / this.totais.totalClientes) * 100 ).toFixed(2)
  }
}
